/* eslint-disable i18next/no-literal-string */
import { useSyncExternalStore } from "react";
import DiagnosticsStore from "@/features/diagnostics/store/diagnostics-store.ts";
import { DiagnosticsEmpty, DiagnosticsGrid } from "../lib/diagnostics-card.tsx";
import PartStatusItem from "./part-status-item.tsx";

export default function PartStatusList() {
    const partStatuses = useSyncExternalStore(DiagnosticsStore.subscribe, () => DiagnosticsStore.partStatuses);

    if (partStatuses.length === 0) {
        return <DiagnosticsEmpty>No parts!</DiagnosticsEmpty>;
    }

    return (
        <DiagnosticsGrid size="md">
            {partStatuses.map((part) => (
                <PartStatusItem key={part.partNo} part={part} />
            ))}
        </DiagnosticsGrid>
    );
}
